"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _AttachmentsActionTypes = require("crm_ui/attachments/data/AttachmentsActionTypes");

var _dispatch = require("crm_data/flux/dispatch");

var _immutable = require("immutable");

var reduceAttachments = function reduceAttachments(attachments) {
  return attachments.reduce(function (reduction, attachment) {
    return reduction.set(attachment.get('id'), attachment);
  }, (0, _immutable.Map)());
};

var AttachmentsActions = {
  addAttachments: function addAttachments(attachments) {
    attachments = reduceAttachments((0, _immutable.fromJS)(attachments));
    return (0, _dispatch.dispatch)(_AttachmentsActionTypes.ATTACHMENTS_UPDATED, attachments);
  }
};
var _default = AttachmentsActions;
exports.default = _default;
module.exports = exports.default;